import { render, staticRenderFns } from "./Binding.vue?vue&type=template&id=943a4aae&scoped=true"
import script from "./Binding.vue?vue&type=script&lang=js"
export * from "./Binding.vue?vue&type=script&lang=js"
import style0 from "./Binding.vue?vue&type=style&index=0&id=943a4aae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "943a4aae",
  null
  
)

export default component.exports